import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useInterestQuestionariesTemplateConfiguration, useTemplate } from "PFApp/hooks";
import { TableColumn } from "PFTypes";
import { useCallback } from "react";

export const useExcludeHiddenColumns = () => {
  const activity = useCurrentActivity();

  const template = useTemplate({ id: activity.template_id });
  const templateSettings = useInterestQuestionariesTemplateConfiguration(template);

  const statementVisible = !(!!templateSettings?.hideOnClosedRoles && activity.state === "complete");

  return useCallback(
    (columns: TableColumn[]) =>
      columns.filter(({ name }) => (name === "statement" ? statementVisible : true)),
    [statementVisible]
  );
};
